





























































































































































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DataDokter from "@/services/DataUtility";
import DataSKDP from "@/services/DataSKDP";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeSKDP } from "@/store/modules/skdp";
import { storeSoap } from "@/store/modules/soap";
import moment from "moment";
import TglKontrolSkdpDatePicker from "@/components/form_components/TglKontrolSkdpDatePicker.vue";
import VCDatePicker from "@/components/form_components/VCDatePicker.vue";
import { storePasien } from "@/store/modules/pasien";
import Skdp from "@/services/new/Skdp";
import MasterReferensi from "@/store/modules/new/MasterReferensi";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";

@Component({
  components: {
    CardModalTtd,
    TglKontrolSkdpDatePicker,
    VCDatePicker
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardInputSKDP extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly register!: string;
  @Prop() dataSkdp!: string;
  @Prop() kronis!: string;
  @Prop({ default: false }) show: boolean;

  @Ref() readonly ttd!: HTMLElement;
  @Ref() readonly diag!: HTMLInputElement;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  checkKronis = false;
  dokter = {};
  diagnosis = "";
  alasan = "";
  rtl = "";
  tglRujukan = "";
  tglKontrol = "";
  sess_login = userModule.user;
  listDokter = {};
  alert = "";
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  err = {};
  modalTtd = false;
  tglShowRujukan = false;
  tglShowKontrol = false;
  searchAlasan = null;
  entriesAlasan = [];
  searchRtl = null;
  entriesRtl = [];
  autofocus = false;
  hintTglKontrol = "";
  loadingTglKontrol = false;
  expandInput = false;
  saving = false;

  get stateInputSkdp() {
    return storeSKDP.inputSkdp;
  }
  get stateSkdp() {
    return storeSKDP.skdp;
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get infoBpjs() {
    return RegisterKunjungan.infoBpjs;
  }

  get rujukanDaysRemaining() {
    return RegisterKunjungan.rujukanDaysRemaining;
  }

  get rujukanDaysWarn() {
    return 30;
  }

  mounted() {
    this.getDpjp();

    storeSKDP.act_autocomplete_alasan(this.searchAlasan);
    storeSKDP.act_autocomplete_rtl(this.searchRtl);

    if (MasterReferensi.holidays.length < 1) {
      MasterReferensi.getHolidays();
    }

    if (this.infoBpjs) {
      this.tglRujukan = this.infoBpjs.tglRujukan;
    }

    this.getSkdp();
  }

  @Watch("dataSkdp")
  getSkdp() {
    if (this.dataSkdp["dokter"] == undefined) {
      this.dokter = { id: this.sess_login.id, nama: this.sess_login.nama };
      this.diagnosis = this.statesoapdetail[0]?.a;
      this.alasan = "";
      this.rtl = "";
      this.tglRujukan = this.infoBpjs ? this.infoBpjs.tglRujukan : "";
      this.tglKontrol = "";
      if (this.kronis == "1") {
        this.checkKronis = true;
      } else {
        this.checkKronis = false;
      }

      if (this.sess_login.unit_group_id == "27") {
        this.alasan = "Belum stabil";

        if (this.kronis == "1") {
          this.rtl = this.statesoapdetail[0]?.p;
        } else {
          this.rtl = "Kontrol rutin";
        }
      }
    } else {
      this.dokter = this.dataSkdp["dokter"];
      this.diagnosis = this.dataSkdp["diagnosis"];
      this.alasan = this.dataSkdp["alasan"];
      this.rtl = this.dataSkdp["rtl"];
      this.tglRujukan = this.dataSkdp["tgl_rujukan"];
      this.tglKontrol = this.dataSkdp["tgl_kunjungan"];
      this.checkKronis = this.dataSkdp["kasus_kronis"];
    }
  }

  passTtd(value) {
    this.$emit("passTtd", value);
  }

  getDpjp() {
    const dktr = DataDokter.getListDokter();
    dktr.then(dktr => {
      this.listDokter = dktr;
    });
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get input() {
    return {
      register_id: this.register,
      pasien_rm: this.statePasien.rm,
      dpjp_id: this.dokter["id"],
      unit_id: this.sess_login["unit_id"],
      tgl_rujukan: this.tglRujukan,
      diagnosis: this.diagnosis,
      alasan: this.alasan,
      rtl: this.rtl,
      tgl_kunjungan: this.tglKontrol,
      user_id: this.sess_login["id"],
      kasus_kronis: this.checkKronis ? "1" : "0"
    };
  }

  simpanSKDP() {
    if (this.readOnly) return;
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      if (!this.saving) {
        this.saving = true;

        const resp = this.dataSkdp["id"]
          ? Skdp.update(this.dataSkdp["id"], this.input)
          : Skdp.create(this.input);

        resp
          .then(dt => {
            if (dt["status"] == 1) {
              storeSKDP.actSkdp_on_reg(this.register);
              storeSKDP.actSKD_on_id(dt["data"].id);
              appModule.NoticeDelay("Berhasil Simpan SKDP");
              this.close();
            }
          })
          .finally(() => {
            this.saving = false;
          });

        this.saving = true;
      }
    }
  }

  close() {
    this.expandInput = false;
    this.$emit("close", this.expandInput);
  }

  get stateAlasan() {
    return storeSKDP.alasan.map(alasan => {
      return alasan.text;
    });
  }

  get stateRtl() {
    return storeSKDP.rtl.map(rtl => {
      return rtl.text;
    });
  }

  @Watch("searchAlasan", { deep: true })
  searchedAlasan(val) {
    if (val === null || val.length < 2) return;
    else {
      this.alasan = val;
    }

    if (this.alasan === this.searchAlasan) return;
  }

  @Watch("searchRtl", { deep: true })
  searchedRtl(val) {
    if (val === null || val.length < 2) return;
    else {
      this.rtl = val;
    }

    if (this.rtl === this.searchRtl) return;
  }

  @Watch("tglKontrol")
  changeTglKontrol(val) {
    if (!val) {
      this.hintTglKontrol = "";
    }
  }

  setTglKontrol(val) {
    this.tglKontrol = val;
  }
}
